<template>
	<AsiDialogFormLayout :title="$t('brand.terms.create')" :open="open" :loading="loading" :valid="valid"
	                     :errors="errors" @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text>
			<v-form v-if="model !== null" v-model="valid">
				<div class="pa-6">
					<AsiTextField v-model="model.name" :rules="model.rules('name')"
					              :label="$t('brand.name')" :placeholder="$t('brand.name')"
					              clearable/>
				</div>
				<v-divider/>
				<div class="pa-6">
					<TranslatedValueFormPart :label="$t('brand.description')" :model="model.description" text-area/>
				</div>
				<v-divider/>
				<div class="pa-6 text-center">
					{{ $t('brand.terms.uploadImageAfterCreation') }}
				</div>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit} from 'vue-property-decorator';
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import BrandCreate from "@/models/brand/BrandCreate";
	import TranslatedValueFormPart from "@/components/translated-value/admin/TranslatedValueFormPart.vue";

	@Component({
		components: {TranslatedValueFormPart, AsiTextField, AsiDialogFormLayout}
	})
	export default class BrandCreateDialog extends AsiDialogForm {

		private model: BrandCreate = new BrandCreate();

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			const form = this.$refs.form as HTMLFormElement;
			this.reset([this.model], form);
			return event;
		}

		private requestSave(): void {
			if (!this.valid) return;
			this.loading = true;
			this.$brandServiceAdmin.create(this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}
	}
</script>

<style scoped lang="scss">

</style>
